const domain = 'easybell'
const tld = 'de'

const subDomains = {
  homepage: {
    feature: 'feature',
    staging: 'staging',
    production: 'www',
  },
  orderForm: {
    feature: 'order-form-feature',
    staging: 'order-form-staging',
    production: 'order-form',
  },
}

function parseFullDomain(product, environment) {
  const subDomain = subDomains[product][environment]
  return `https://${subDomain}.${domain}.${tld}/`
}

const defaultApiPath = 'api/'

function parseFullApiUrl(product, environment) {
  return parseFullDomain(product, environment) + defaultApiPath
}

module.exports = {
  dev: {
    devServer: {
      host: 'localhost', // 'local.easybell.de'
      target: {
        feature: parseFullDomain('orderForm', 'feature'),
        staging: parseFullDomain('orderForm', 'staging'),
        production: parseFullDomain('orderForm', 'production'),
      },
    },
    baseApiUrl: {
      relative: '/' + defaultApiPath,
      absolute: {
        feature: parseFullApiUrl('orderForm', 'feature'),
        staging: parseFullApiUrl('orderForm', 'staging'),
        production: parseFullApiUrl('orderForm', 'production'),
      },
    },
  },
  parseFullDomain,
}
